import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../axios/api";

// ✅ Login
export const loginUser = createAsyncThunk(
  "user/login",
  async ({ email, senha }, { rejectWithValue }) => {
    try {
      const response = await api.post("/auth/users/login", { email, senha });
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erro no login");
    }
  }
);

// ✅ Restaurar user/token do localStorage
export const checkAuth = createAsyncThunk(
  "user/checkAuth",
  async (_, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = localStorage.getItem("token");
      if (user && token) return { user, token };
      return rejectWithValue("Não autenticado");
    } catch (err) {
      return rejectWithValue("Erro ao verificar autenticação");
    }
  }
);

// ✅ Logout chamando backend
export const logout = createAsyncThunk(
  "user/logout",
  async (userId, { rejectWithValue }) => {
    try {
      await api.put(`/auth/users/logout/${userId}`);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      return true;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erro no logout");
    }
  }
);

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
  },
  extraReducers: (builder) => {
    builder
      // LOGIN
      .addCase(loginUser.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        localStorage.setItem("user", JSON.stringify(action.payload.user));
        localStorage.setItem("token", action.payload.token);
      })
      .addCase(loginUser.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      // CHECK AUTH
      .addCase(checkAuth.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(checkAuth.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(checkAuth.rejected, (state) => { state.loading = false; state.user = null; state.token = null; })

      // LOGOUT
      .addCase(logout.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.token = null;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
